import React from "react";
import { connect, useSelector } from "react-redux";
import { Field , reduxForm } from "redux-form";
import { RenderInput } from "../Common/FormFields";
import { RootState } from "../../reducers";
import CurrencyFormat from "react-currency-format";

interface LoanProps {
    ID: any;
    balanceRemaining: any;
    loanName: {name: string, ref: string};
    nextRepaymentDate: any;
    paidLoanAmount: any;
    status: any;
    interest: any;
    principal: any;
    payoutAmount: any;
};

const validate = (values, props) => {
    const errors = {};
    if (
      values.paymentAmount &&
      /^(0|[1-9][0-9]*)$/i.test(values.paymentAmount) &&
      parseFloat(values.paymentAmount) > parseFloat(props.paymentAmount)
    ) {
      errors["paymentAmount"] = "You can't pay more than you owe.";
    }
    return errors;
};

let PaymentInput = (props) => {
    const { selectedLoan } = useSelector<RootState, {selectedLoan: LoanProps}>(state => ({
        selectedLoan: state.loans.selectedLoan
    }));

    return (
        <>
            <div className="content">
                <h4>How much do you want to pay?</h4>
                <Field
                placeholder=""
                name="paymentAmount"
                label=""
                className="paymentAmount"
                prefix="$"
                component={RenderInput}
                />
            </div>
            <div className="small-text">
                Maximum amount of{" "}
                <strong>
                {selectedLoan.payoutAmount !== 0 || selectedLoan.payoutAmount ? (
                    <CurrencyFormat
                    value={parseFloat(selectedLoan.payoutAmount).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    />
                ) : (
                    0.0
                )}{" "}
                </strong>
            </div>
            <div className="small-text">
                consists of{" "}
                <strong>
                {selectedLoan.principal !== "" || selectedLoan.principal ? (
                    <CurrencyFormat
                    value={parseFloat(selectedLoan.principal).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    />
                ) : (
                    0.0
                )}
                </strong>
                {" "}in principal{" "}
            </div>
            <div className="small-text">
                and{" "}
                <strong>
                {selectedLoan.interest !== "" || selectedLoan.interest ? (
                    <CurrencyFormat
                    value={parseFloat(selectedLoan.interest).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    />
                ) : (
                    0.0
                )}{" "}
                </strong>
                in interest
            </div>
        </>
    );
};


PaymentInput = reduxForm({
  form: "PaymentInputForm",
  enableReinitialize: true,
  validate,
})(PaymentInput);

export default PaymentInput;